export function isIosPWA() {
  // iOS WebView Detection (WKWebView/UIWebView)
  if (typeof window !== "undefined") {
    const ua = navigator?.userAgent || "";
    const isIOS = /iPhone|iPad|iPod/i.test(ua);

    if (isIOS && !window.MSStream) {
      // FIRST: Check for specific native app identifiers in UA
      // PWAShell = TG native iOS app wrapper identifier
      const hasNativeAppIdentifier = /PWAShell/i.test(ua);
      if (hasNativeAppIdentifier) {
        return true;
      }

      const hasSafari = /Safari/i.test(ua);

      // Third-party browsers on iOS (Chrome, Firefox, Edge, Opera)
      // These are NOT native apps, just apps using iOS Safari engine
      const isThirdPartyBrowser = /CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);

      // Native iOS WebViews don't include "Safari" in user agent
      // (but we exclude third-party browsers which also lack Safari)
      if (!hasSafari && !isThirdPartyBrowser) {
        return true;
      }

      // Additional iOS WebView indicator: webkit.messageHandlers
      // Present in WKWebView but not in standard Safari
      // (though can be present in PWAs, so we combine with other checks)
      const hasWebkitMessageHandlers = !!(window.webkit && window.webkit.messageHandlers);

      if (hasWebkitMessageHandlers && !hasSafari && !isThirdPartyBrowser) {
        return true;
      }
    }
  }
  return false;
}
/**
 * Detects if the application is running as an installed Progressive Web App (PWA)
 *
 * Supports detection across multiple platforms and browsers:
 * - iOS Safari (standalone mode)
 * - Android Chrome (display modes: standalone, fullscreen, minimal-ui, window-controls-overlay)
 * - Android TWA (Trusted Web Activity)
 * - Samsung Browser (height-based detection)
 * - Desktop browsers (Chrome, Edge, etc.)
 *
 * @returns {boolean} True if running as an installed PWA, false otherwise
 *
 */
export function isPWAInstalled() {
  const ua = navigator?.userAgent || "";

  const isStandaloneIOS =
    typeof window.navigator.standalone === "boolean" && window.navigator.standalone;
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
  const isFullscreen = window.matchMedia("(display-mode: fullscreen)").matches;
  const isMinimalUI = window.matchMedia("(display-mode: minimal-ui)").matches;
  const isOverlay = window.matchMedia("(display-mode: window-controls-overlay)").matches;

  // Android Trusted Web Activity
  const isTWA =
    typeof document?.referrer === "string" && document.referrer.startsWith("android-app://");

  const isSamsungBrowser = /SamsungBrowser/i.test(ua);
  let isStandaloneSamsung = false;

  if (isSamsungBrowser) {
    const screenHeight = window.screen.height || 0;
    const innerHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    const heightDifference = Math.abs(screenHeight - innerHeight);
    isStandaloneSamsung = heightDifference < 50;
  }

  // Chrome on Mac specific handling - check screen usage for fullscreen
  const isChromeOnMac = /Chrome/.test(ua) && /Macintosh/.test(ua);
  let isActualPWA = isFullscreen;

  if (isChromeOnMac && isFullscreen) {
    const screenUsage = window.innerHeight / window.screen.height;
    isActualPWA = screenUsage >= 0.98;
  }

  // const isAndroid = /Android/i.test(ua);
  // // Some Android WebViews lack Chrome version info
  // const isLacksChrome = !/Chrome\/[\d.]+/i.test(ua) && isAndroid;

  return (
    isStandaloneIOS ||
    isStandalone ||
    isActualPWA ||
    isMinimalUI ||
    isOverlay ||
    isTWA ||
    isStandaloneSamsung ||
    isIosPWA()
    // isLacksChrome
  );
}
